import Vue from 'vue'
import Vuex from 'vuex'
import { showList as categoryShowList } from '@/api/category'
import { showList as postShowList } from '@/api/post'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    lang: window.localStorage.getItem('lang'),
    device: 'desktop',
    previewImgs: {},
    photoData: [],
    contactDialogShow: false,
  },
  mutations: {
    SET_LANG(state, lang) {
      state.lang = lang;
    },

    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },

    SET_PREVIEW_IMGS: (state, imgs) => {
      state.previewImgs = imgs
    },

    SET_PHOTO_DATA: (state, data) => {
      state.photoData = data
    },

    TOGGLE_CONTACT_DIALOG: (state, isShow) => {
      state.contactDialogShow = isShow
    }
  },
  actions: {
    setLang({ commit, state }, lang) {
      window.localStorage.setItem('lang', lang);
      commit('SET_LANG', lang)
    },

    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },

    toggleContactDialogShow({ commit }, isShow) {
      commit('TOGGLE_CONTACT_DIALOG', isShow)
    },

    setPreviewImgs({ commit }, imgs) {
      commit('SET_PREVIEW_IMGS', imgs)
    },

    getcontactDialogShow({ commit }, callback) {
      categoryShowList().then(cateList => {
        if(cateList.code == 20000) {
          postShowList().then(postList => {
            if(postList.code == 20000) {
              cateList.list.forEach(cate => {
                cate.post = [];
                postList.list.forEach(post => {
                  if(post.cid == cate.id) {
                    cate.post.push(post);
                  }
                });
              })

              commit('SET_PHOTO_DATA', cateList.list)
              callback && callback(cateList.list);
            }
            
          })
        }
      })
    },

    getPhotoData({ commit }, callback) {
      categoryShowList().then(cateList => {
        if(cateList.code == 20000) {
          postShowList().then(postList => {
            if(postList.code == 20000) {
              cateList.list.forEach(cate => {
                cate.post = [];
                postList.list.forEach(post => {
                  if(post.cid == cate.id) {
                    cate.post.push(post);
                  }
                });
              })

              commit('SET_PHOTO_DATA', cateList.list)
              callback && callback(cateList.list);
            }
            
          })
        }
      })
    },
  }
})
